/**************************************************
 * Nombre:       Seccion_Inicio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Bit_Nova from "./Componentes/Bit_Nova";
import Tarjeta_Deposito from "../Tarjetas_Especiales/Tarjeta_Deposito";
import Tarjeta_Activos from "../Tarjetas_Especiales/Tarjeta_Activos";
import Inicio_Noticias from "./Componentes/Inicio_Noticias";
import {useEffect} from "react";
import {irArriba} from "../../Utilidades/irArriba";


const Seccion_Inicio = () => {
    useEffect(() => {
        irArriba()
    },[])
    return (
        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px', color: 'white', pb: 10}}
                spacing={4}
            >

                <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'flex-start', ml: -8, mb: 6}}>
                    <Bit_Nova/>
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 5}} sx={{justifyContent: 'flex-start'}}>
                    <Tarjeta_Deposito/>
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 5}} sx={{justifyContent: 'flex-start'}}>
                    <Tarjeta_Activos />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start', mt: 6}}>
                    <Inicio_Noticias/>
                </Grid>


            </Grid>
        </Grid>
    )

}
export default Seccion_Inicio